import { Fade, Flex, Spacer, Text, useDisclosure } from '@chakra-ui/react'
import React from 'react'
import { FaAngleDown, FaAngleUp } from 'react-icons/fa'

import SidebarLink from './SidebarLink'
import SidebarLinkGroup from './SidebarLinkGroup'
import SideBarFunctionButton from './SidebarFunctionButton'

const SidebarSection = ({ title, links = [], defaultOpen = false }) => {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: defaultOpen })

  return (
    <Flex direction={'column'} gap={1}>
      <Flex color="hsla(0,0%,100%,.6)" w="100%" p="2" onClick={onToggle} _hover={{ cursor: 'pointer' }}>
        <Text casing="uppercase" fontWeight="700" fontSize="xs">
          {title}
        </Text>
        <Spacer />
        {isOpen ? <FaAngleUp /> : <FaAngleDown />}
      </Flex>
      <Fade in={isOpen}>
        <Flex direction={'column'} gap={'1'} display={isOpen ? 'flex' : 'none'}>
          {links.map((link) => {
            if (Array.isArray(link.childLinks)) {
              return <SidebarLinkGroup key={link.name} {...link} />
            }
            return (
              <SidebarLink
                key={link.path}
                name={link.name ?? ''}
                path={link.path}
                icon={link.icon}
                onClick={link.handleLinkClick}
              />
            )
          })}
        </Flex>
      </Fade>
    </Flex>
  )
}

export default SidebarSection
